import styled from '@emotion/styled';
import { useFormContext } from 'react-hook-form';
import { TagsInput } from 'wisestep-base';

const EmailInputField = styled(TagsInput)(() => ({
  '.MuiOutlinedInput-root': {
    fieldset: {
      border: 'none',
    },
    padding: 0,
    margin: 0,
  },
  ':inputProps': {
    padding: 0,
  },
}));

export const EmailBccOrCcInput = ({ name }: { name: 'cc' | 'bcc' }) => {
  const { setValue } = useFormContext();
  return (
    <EmailInputField
      name={name}
      onTagsChange={
        name === 'cc'
          ? (emails: string[]) => setValue('cc', emails)
          : (emails: string[]) => setValue('bcc', emails)
      }
      initialValue={[]}
      multiple={true}
    />
  );
};
